import { DirectorySort } from "@common/constants/counterparty";
import { GetCounterpartiesQuery } from "@common/schemas/counterparty.schema";
import { FiltersTypes } from "@common/types/filters/general";
import { DirectoryFilters } from "@components/settings/Directory/lib";
import {
    toCounterpartiesTaskQueryFilters,
    toPinnedCounterpartiesQueryFilters,
} from "./counterpartiesTaskFilters";

interface BuildCounterpartiesTaskQueryParams {
    scope: DirectoryFilters;
    sort: DirectorySort;
    viewFilters: FiltersTypes;
    originalFilters?: FiltersTypes;
    stickyCounterpartiesIds?: string[];
    extraFilters?: Partial<GetCounterpartiesQuery>;
}

export function buildCounterpartiesTaskQuery({
    scope,
    sort,
    viewFilters,
    originalFilters,
    stickyCounterpartiesIds,
    extraFilters,
}: BuildCounterpartiesTaskQueryParams): GetCounterpartiesQuery {
    const isSticky = originalFilters !== undefined;
    const criteria = originalFilters ?? viewFilters;
    const hasPinnedMembership =
        isSticky || !!viewFilters.counterpartiesIds?.length;
    return {
        includeUsageStats: true,
        search: scope.search,
        startDate: scope.startDate,
        endDate: scope.endDate,
        sort,
        entityIds: scope.entityIds,
        basis: scope.basis,
        counterpartiesIds: isSticky
            ? stickyCounterpartiesIds
            : viewFilters.counterpartiesIds,
        ...(hasPinnedMembership
            ? toPinnedCounterpartiesQueryFilters(criteria)
            : toCounterpartiesTaskQueryFilters(criteria)),
        ...extraFilters,
    };
}
